/**
 * CarPurchaseDraft listend buy-car form forward and backward buttons and
 * sends a car purchase draft to Stage for more processing.
 */
class CarPurchaseDraft {

  /**
   * @constructor
   * @param {HTMLElement} element to bind to
   */
  constructor(element) {
    this._element = element;
    this.bind();
  }

  /**
   * Bind event listeners
   */
  bind() {
    const contentHolder = document.querySelector('.buy-car-wrapper');
    if(contentHolder) {
      contentHolder.addEventListener('click', this._onFormClicked.bind(this) );
    }
  }

  /**
   * Send a car purchase draft to Stage
   */
  async _sendCarPurchaseDraft() {
    const formData = new FormData(this._element);
    const data = Object.fromEntries(formData)

    //Pick only what you need, no more, no less..
    const carPurchaseDrafData = {
      firstname: data['user[firstname]'],
      lastname: data['user[lastname]'],
      email: data['user[email]'],
      phone: data['user[phone]'],
      city: data['user[city]'],
      zip: data['user[zip]'],
      address: data['user[address]'],
      netwheels_id: data['car[netwheeldId]'],
      license: data['car[license]'],
      trade_car_license: data['tradeCar[license]'],
      trade_car_driven: data['tradeCar[driven]'],
      trade_car_choise: data['tradeCar[choice]'] === '1'
    };

    //Fire and forget...
    if( carPurchaseDrafData.trade_car_choise ) {
      fetch('/stage-ajax/v10-car-purchase-draft/',{
        method: 'POST',
        body: JSON.stringify( carPurchaseDrafData ),
        headers: {
          'Content-type': 'application/json;'
        }
      });
    }
  }

  /**
   * Called when a form element is clicked
   * @param {Event} event click event
   */
  _onFormClicked(event) {
    const target = event.target;
    if( this._element.contains( target ) && !target.classList.contains('disabled') &&
       (target.classList.contains('continue') || target.classList.contains('back')) ) {
      this._sendCarPurchaseDraft();
    }
  }

  /**
   * Used to initialize CarPurchaseDraft in master.js
   */
  static init() {
    document.querySelectorAll('form.buy-car').forEach(element => {
      new CarPurchaseDraft( element );
    });
  }
}

export default {
  CarPurchaseDraft
}

export {
  CarPurchaseDraft
}
